import React, { Component } from "react";
import { Link } from "react-router-dom";
import { getDateString } from "../../helpers";
import "./DayCard.css";

class DayCard extends Component {
  render() {
    const { day, monthday } = getDateString(this.props.cardDate);
    return (
      <Link to={`/app/instructor-dashboard/${this.props.cardDate}`}>
        <div className="day-card">
          <div className="day">{day}</div>
          <div className="date">{monthday}</div>
          <div className="appointment-card-wrapper">
            <div className="appointment-card">
              <span className="apointment-label">Appointments: </span>{" "}
              {this.props.numAppointment}
            </div>
          </div>
        </div>
      </Link>
    );
  }
}

export default DayCard;
